import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";
import placeholder from "~/assets/placeholder-image.svg";
import { loadEventsAction } from "~/Admin/redux/actions/event";
import ValidationError from "~/Components/Forms/ValidationError";
// import DatePicker from "~/Components/DatePicker/DatePicker";
import moment, { locale } from "moment";
import { adminHttp } from "~/Admin/services/http";
import Translated from "~/Admin/AdminMultilang/Translated";
import { DatePicker, MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import "./admineventdetails.scss";
import { handleNullDate } from '../../../services/helpers';
import { capitalize } from '../../../helpers/utils';
import update from 'immutability-helper';
import {TextTranslateString} from "~/Components/TextTranslate/TextTranslate";
import ToggleSwitch from "~/Components/ToggleSwitch/ToggleSwitch";

const AdminEventDetails = ({ match, event, ...props }) => {

    const [form, setForm] = useState({
        name: event.name,
        location: event.location,
        partner: event.partner,
        start: moment(event.start),
        end: moment(event.end),
        rsvp_deadline: moment(event.rsvp_deadline),
        reg_deadline: moment(event.reg_deadline),
        translations: event.translations,
        survey_guest_link: event.survey?.guest?.link,
        survey_guest_deadline: handleNullDate(event.survey?.guest?.deadline),
        survey_host_link: event.survey?.host?.link,
        survey_host_deadline: handleNullDate(event.survey?.host?.deadline),
        gdpr_consent: event?.gdpr_consent || {},
        ground_transfer: event.ground_transfer,
    });
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');
    const [currentLocale, setCurrentLocale] = useState(Object.keys(event?.gdpr_consent)[0]);

    const updated = () => {
        props.dispatch(loadEventsAction());
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({ ...form, [name]: value });
    };

    const handleChangeGDPR = (e) => {
        const locale = e.target.name;
        const value = e.target.value;

        setForm(
            update(form, {gdpr_consent: {[locale]: {$set: value}}})
        )
    }

    const translationChanged = (values) => {
        setForm({ ...form, translations: values });
    };

    const handleDateChange = (name, value) => {
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = () => {
        adminHttp
            .put(`/events/${event.id}`, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');
                updated();
            }).catch((error) => {
                setMessage(null);
                setError(error.response?.data);
            });
    };

    useEffect(() => {
        setForm({
            name: event.name,
            location: event.location,
            partner: event.partner,
            start: moment(event.start),
            end: moment(event.end),
            rsvp_deadline: moment(event.rsvp_deadline),
            reg_deadline: moment(event.reg_deadline),
            translations: event.translations,
            visa_link: event.visa_link,
            survey_guest_link: event.survey?.guest?.link || '',
            survey_guest_deadline: handleNullDate(event.survey?.guest?.deadline),
            survey_host_link: event.survey?.host?.link || '',
            survey_host_deadline: handleNullDate(event.survey?.host?.deadline),
            gdpr_consent: event?.gdpr_consent || {},
            ground_transfer: event.ground_transfer,
        })
    }, [event])

    return (
        <div className="admin-event-details">
            <h2>Your Event</h2>
            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <div className="row">

                        <div className="col-4">
                            <h3>Event Logo</h3>
                            <img className="img-thumbnail mb-2 d-block" src={event.logo_image.download_url || placeholder} />

                            <AdminImageUploader
                                image={event.logo_image}
                                onChanged={updated}
                                className="text-primary cursor-pointer d-block">Edit Event Logo</AdminImageUploader>
                        </div>

                        <div className="col-8">
                            <h3>Event Details</h3>

                            {message && (
                                <div className="alert alert-success" role="alert">
                                    {message}
                                </div>
                            )}

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error.message || "Error saving event!"}
                                </div>
                            )}

                            <div className="form-group required">
                                <label>Event Name</label>
                                <label>Event Name</label>

                                <Translated translations={form.translations} onChanged={translationChanged}>
                                    <input
                                        onChange={handleChange}
                                        value={form.name}
                                        name="name"
                                        type="text"
                                        className="form-control" />
                                </Translated>

                                <ValidationError errors={error?.errors} name="name" />
                            </div>

                            <div className="form-group required">
                                <label>Event Location</label>

                                <Translated translations={form.translations} onChanged={translationChanged}>
                                    <input
                                        onChange={handleChange}
                                        value={form.location}
                                        name="location"
                                        type="text"
                                        className="form-control" />
                                </Translated>

                                <ValidationError errors={error?.errors} name="location" />
                            </div>

                            <div className="form-group required">
                                <label>Event Partner</label>

                                <Translated translations={form.translations} onChanged={translationChanged}>
                                    <input
                                        onChange={handleChange}
                                        value={form.partner}
                                        name="partner"
                                        type="text"
                                        className="form-control" />
                                </Translated>

                                <ValidationError errors={error?.errors} name="partner" />
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Event Dates</h3>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group required d-flex flex-column h-100">
                                    <label>Start Date</label>

                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.start}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('start', date)} />

                                    <ValidationError errors={error?.errors} name="start" />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group required d-flex flex-column h-100">
                                    <label>End Date</label>

                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.end}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('end', date)} />

                                    <ValidationError errors={error?.errors} name="end" />
                                </div>
                            </div>

                            <div className="col-3">
                                <div className="form-group required d-flex flex-column h-100">
                                    <label>Rsvp Deadline</label>

                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.rsvp_deadline}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('rsvp_deadline', date)} />

                                    <ValidationError errors={error?.errors} name="rsvp_deadline" />
                                </div>
                            </div>

                            <div className="col-3">
                                <div className="form-group required d-flex flex-column h-100">
                                    <label>Registration Deadline</label>

                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.reg_deadline}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('reg_deadline', date)} />

                                    <ValidationError errors={error?.errors} name="reg_deadline" />
                                </div>
                            </div>

                        </div>
                    </MuiPickersUtilsProvider>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>VISA Requirements</h3>
                    <div className="form-group required">
                        <label>Link</label>
                        <div>
                            <input
                                className="form-control w-100"
                                type="text"
                                name="visa_link"
                                value={form.visa_link}
                                onChange={handleChange}
                            />

                            <ValidationError errors={error?.errors} name="visa_link" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Survey Email</h3>
                    <div className="row">
                        <div className="col-6 form-group">
                            <label>Guest Survey Link</label>
                            <div>
                                <input
                                    className="form-control w-100"
                                    type="text"
                                    name="survey_guest_link"
                                    value={form?.survey_guest_link}
                                    onChange={handleChange}
                                />

                                <ValidationError errors={error?.errors} name="survey_guest_link" />
                            </div>
                        </div>

                        <div className="col-6 form-group d-flex flex-column">
                            <label>Survey deadline</label>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.survey_guest_deadline}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('survey_guest_deadline', date)}
                                    />
                                </MuiPickersUtilsProvider>

                                <ValidationError errors={error?.errors} name="survey_guest_deadline" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 form-group">
                            <label>Host Survey Link</label>
                            <div>
                                <input
                                    className="form-control w-100"
                                    type="text"
                                    name="survey_host_link"
                                    value={form?.survey_host_link}
                                    onChange={handleChange}
                                />

                                <ValidationError errors={error?.errors} name="survey_host_link" />
                            </div>
                        </div>

                        <div className="col-6 form-group d-flex flex-column">
                            <label>Survey deadline</label>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/YYY"
                                        views={["year", "month", "date"]}
                                        value={form.survey_host_deadline}
                                        InputProps={{
                                            style: {
                                                borderRadius: 0
                                            },
                                        }}
                                        PopoverProps={{
                                            PaperProps: {
                                                style: {
                                                    borderRadius: 0,
                                                },
                                            },
                                        }}
                                        onChange={(date) => handleDateChange('survey_host_deadline', date)}
                                    />
                                </MuiPickersUtilsProvider>

                                <ValidationError errors={error?.errors} name="survey_host_deadline" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>GDPR Consent Form</h3>
                    <div className="row">
                        <div className="col-12">
                            <select
                                name="gdpr-locale"
                                className="form-control mb-2"
                                defaultValue={currentLocale}
                                onChange={(e) => setCurrentLocale(e.target.value)}
                            >
                                {Object.keys(form?.gdpr_consent).map((locale, idx) =>
                                    <option key={`gdpr_locale${idx}`} value={locale}>{capitalize(locale)}</option>
                                )}
                            </select>
                        </div>

                        <div className="col-12 form-group">
                            <label>{`GDPR Consent Form Link (${currentLocale})`}</label>
                            <div>
                                <input
                                    className="form-control w-100"
                                    type="text"
                                    name={currentLocale}
                                    value={form?.gdpr_consent?.[currentLocale] || ''}
                                    onChange={handleChangeGDPR}
                                />

                                <ValidationError errors={error?.errors} name={`gdpr_consent`} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Travel options</h3>
                    <div className="row">
                        <div className="col-12">

                        </div>

                        <div className="col-12 form-group">
                            <label>Show ground transfers question</label>
                            <div>
                                <ToggleSwitch
                                    label2={TextTranslateString("travel-switch-ground-transfers-enable", "Disable or enable ground transfer question", props.currentLanguage, props.translations)}
                                    onChange={(e) => {
                                        setForm({ ...form, ground_transfer: !form.ground_transfer });
                                    }}
                                    isChecked={form.ground_transfer}
                                    id="travelGroundTransfersEnable"
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Save
            </button>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventDetails);
